
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardImage from "@/components/common/CardImage.vue";

  @Component({
    components: {
      CardImage,
    },
  })
  export default class EmployeeCardAvatar extends Vue {
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, default: "" }) readonly containerClasses!: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
  }
